import { Box } from '@mui/material'
import Entity from '../Entity/EntityList'
import { useParams } from 'react-router-dom'
import { ReactElement } from 'react'

const EntityPage = (): ReactElement => {
    const routeParams = useParams()
    const templateId = routeParams.templateId

    return (
        <Box sx={{ height: '100%' }} padding="10px">
            {templateId && <Entity templateId={templateId} />}
        </Box>
    )
}

export default EntityPage
